export class BillingGrid {
    campaignId: string;
    itemStartDate: Date;
    itemEndDate: Date;
    serviceProvided: boolean;
    billed: boolean;
    eligibleToGenBill: boolean;
}